import { FacilityTypes } from '../../../../common';
import { useNetworkGroups } from '../../../app-init-data/useNetworkGroups';

export const useNetworkInfo = ({
	planNetworkCounts,
	networkGroupId,
}: {
	planNetworkCounts: { facilityTypeId: number; count: number; display: boolean }[];
	networkGroupId: number;
}) => {
	const { getNetworkById } = useNetworkGroups();
	const networkName = getNetworkById(networkGroupId)?.name ?? '';

	const networkFacilitiesCount = {
		hospital: 0,
		clinic: 0,
		pharmacy: 0,
	};

	planNetworkCounts?.forEach((network) => {
		switch (network.facilityTypeId) {
			case FacilityTypes.Hospital: {
				networkFacilitiesCount.hospital = network.count;

				return;
			}
			case FacilityTypes.Clinic: {
				networkFacilitiesCount.clinic = network.count;

				return;
			}
			case FacilityTypes.Pharmacy: {
				networkFacilitiesCount.pharmacy = network.count;

				return;
			}
		}
	});

	return {
		networkName,
		networkFacilitiesCount,
	};
};
